import React from 'react';
import PropTypes from 'prop-types';
import Facet from './Facet';

const Facets = ({
    attributes,
    onAttributeChange,
    onClearAttributes,
    expandedFacets,
    onToggleFacetExpanded,
    updateOnToggle,
    showMoreFacets,
    onToggleShowMoreFacet
}) => {
    const showClearAttributes = attributes.filter(
        attribute => attribute.Values.filter(
            value => value.Checked).length > 0).length > 0;

    const activeFilters = attributes.map(attr => ({
        ...attr,
        values: attr.Values.filter(value => value.Checked)
    }));

    return (
        <div className="facets">
                    <div className="filter-products-row py-3 py-md-0">
                        <div className="headline headline-xs">
                    REFINE BY
                        </div>
                {
                    activeFilters.map(attr => (
                        attr.values.map(filter => (
                            <span className="filter clear-all-filters"
                                key={filter.Name}
                                onClick={(e) => { onAttributeChange(attr.Name, filter.Name) }}>
                                {filter.Name}
                                <i className="fas fa-times ml-1"></i>
                            </span>
                        ))
                    ))
                }
                        {showClearAttributes &&
                            <a
                                onClick={onClearAttributes}
                                className="clear-all-filters d-block"
                                href="#"
                            >
                                Clear all
                            </a>
                }
                
                    </div>
            {
                attributes.map((attribute, i) => {
                    const expanded = expandedFacets.indexOf(attribute.Name) > -1;
                    const showMore = showMoreFacets.indexOf(attribute.Name) > -1;
                    return (
                        <div className="mb-3" key={attribute.Name}>
                            <Facet
                                name={attribute.Name}
                                displayName={attribute.DisplayName}
                                values={attribute.Values}
                                onAttributeChange={onAttributeChange}
                                expanded={expanded}
                                onToggleFacetExpanded={onToggleFacetExpanded}
                                updateOnToggle={updateOnToggle}
                                showMore={showMore}
                                onToggleShowMore={onToggleShowMoreFacet}
                            />
                        </div>
                    );
                })
            }
        </div>
    );
};

Facets.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    onAttributeChange: PropTypes.func,
    onClearAttributes: PropTypes.func,
    expandedFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleFacetExpanded: PropTypes.func,
    updateOnToggle: PropTypes.bool,
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func,
};

export default Facets;